module.exports = "577017a416676bb0f9fee5e0fc01ef1b.wav";


//////////////////
// WEBPACK FOOTER
// ./assets/sfx/laser.wav
// module id = 93
// module chunks = 0